import { render, staticRenderFns } from "./Backlinks.vue?vue&type=template&id=2e7bff72"
import script from "./Backlinks.vue?vue&type=script&lang=js"
export * from "./Backlinks.vue?vue&type=script&lang=js"
import style0 from "./Backlinks.vue?vue&type=style&index=0&id=2e7bff72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports